/***
 * @Author: ZhaoG
 * @Date: 2025-04-29 08:27:30
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-06 16:01:28
 * @FilePath: \gcp-fe\src\app\procurementNotice\js\formOptions.js
 * @Description: 搜索条件配置
 */

import Cookies from "js-cookie";

export default {
  // 公告类型
  typeOptions: [
    { value: 1, label: "公开采购公告" },
    {
      value: 2,
      label: "邀请采购公告",
      isNotLogin: Cookies.get("access_token") ? "2" : "1"
    },
    { value: 3, label: "评标/评审结果公示", isNotLogin: "2" },
    { value: 4, label: "中标结果公示", isNotLogin: "2" },
    { value: 5, label: "中标通知", isNotLogin: "2" },
    { value: 6, label: "补遗公告", isNotLogin: "2" },
    { value: 7, label: "流标公告", isNotLogin: "2" },
    { value: 8, label: "业务公告" }
  ],
  // 采购方式
  methodOptions: [
    { value: "0", label: "全部", isShow: true },
    { value: "1", label: "公开招标", isShow: true },
    { value: "2", label: "邀请招标", isShow: false },
    {
      value: "3",
      label: "询比",
      isShow: true,
      option: [
        { label: "公开询比", value: "3002", isDisabled: false },
        {
          label: "邀请询比",
          value: "3001",
          isNotLogin: Cookies.get("access_token") ? "2" : "1",
          isDisabled: true
        }
      ]
    },
    {
      value: "4",
      label: "谈判",
      isShow: true,
      option: [
        { label: "公开谈判", value: "4002", isDisabled: false },
        {
          label: "邀请谈判",
          value: "4001",
          isNotLogin: Cookies.get("access_token") ? "2" : "1",
          isDisabled: true
        }
      ]
    },
    {
      value: "5",
      label: "竞价",
      isShow: true,
      option: [
        { label: "公开竞价", value: "5002", isDisabled: false },
        {
          label: "邀请竞价",
          value: "5001",
          isNotLogin: Cookies.get("access_token") ? "2" : "1",
          isDisabled: true
        },
        { label: "废旧物资处置", value: "5003", isDisabled: false }
      ]
    },
    {
      value: "6",
      label: "其它采购",
      isShow: true,
      option: [
        { label: "公开单一来源", value: "6001" },
        { label: "线下公开招标", value: "6002" },
        { label: "线下公开询价", value: "6003" },
        { label: "公开合作谈判", value: "6004" }
      ]
    }
  ],

  timeOptions: [
    { value: 0, label: "全部" },
    { value: 3, label: "近3天" },
    { value: 7, label: "近一周" },
    { value: 30, label: "近一个月" }
  ],

  statusOptions: [
    { value: "", label: "全部" },
    { value: 0, label: "报名中" },
    { value: 1, label: "已结束" }
  ],
  statusOptions0: [
    { value: "", label: "全部" },
    { value: 0, label: "公示中" },
    { value: 1, label: "已结束" }
  ],
  wuziOptions: [
    {
      value: "1",
      label: "陆上施工设备",
      list: [
        {
          value: "1 - 1",
          label: "陆上施工设备"
        }
      ]
    },

    {
      value: "2",
      label: "水上施工设备",
      list: [
        {
          value: "2 - 1",
          label: "水上施工设备"
        }
      ]
    },
    {
      value: "3",
      label: "其他设备",
      list: [
        {
          value: "14 - 1",
          label: "其他设备"
        }
      ]
    }
  ],
  categoryOptions: [
    // { value: 0, label: "全部" },
    { value: 1, label: "港航", data: [] },
    { value: 2, label: "疏浚", data: [] },
    { value: 3, label: "公路", data: [] },
    { value: 4, label: "桥梁", data: [] },
    { value: 5, label: "隧道", data: [] },
    { value: 6, label: "轨道交通", data: [] },
    { value: 7, label: "房建业务", data: [] },
    { value: 8, label: "市政公用", data: [] },
    { value: 9, label: "机场", data: [] },
    { value: 10, label: "机电", data: [] },
    { value: 11, label: "水利水电", data: [] },
    { value: 12, label: "生态环保", data: [] },
    { value: 13, label: "绿色能源", data: [] },
    { value: 14, label: "其他业务", data: [] }
  ],
  categoryOptions0: [
    {
      value: "1",
      label: "公路",
      list: [
        {
          value: "1 - 1",
          label: "公路"
        }
      ]
    },
    {
      value: "2",
      label: "桥梁",
      list: [
        {
          value: "2 - 1",
          label: "桥梁"
        }
      ]
    },
    {
      value: "3",
      label: "隧道",
      list: [
        {
          value: "3 - 1",
          label: "隧道"
        }
      ]
    },
    {
      value: "4",
      label: "港航",
      list: [
        {
          value: "4 - 1",
          label: "港航"
        }
      ]
    },
    {
      value: "5",
      label: "疏浚",
      list: [
        {
          value: "5 - 1",
          label: "疏浚"
        }
      ]
    },
    {
      value: "6",
      label: "轨道交通",
      list: [
        {
          value: "6 - 1",
          label: "轨道交通"
        }
      ]
    },

    {
      value: "8",
      label: "市政共用",
      list: [
        {
          value: "8 - 1",
          label: "市政共用"
        }
      ]
    },
    {
      value: "9",
      label: "机场",
      list: [
        {
          value: "9 - 1",
          label: "机场"
        }
      ]
    },
    {
      value: "10",
      label: "机电",
      list: [
        {
          value: "10 - 1",
          label: "机电"
        }
      ]
    },
    {
      value: "11",
      label: "水利水电",
      list: [
        {
          value: "11 - 1",
          label: "水利水电"
        }
      ]
    },
    {
      value: "12",
      label: "生态环保",
      list: [
        {
          value: "12 - 1",
          label: "生态环保"
        }
      ]
    },
    {
      value: "13",
      label: "绿色融合",
      list: [
        {
          value: "13 - 1",
          label: "绿色融合"
        }
      ]
    },
    {
      value: "14",
      label: "房建",
      list: [
        {
          value: "14 - 1",
          label: "房建"
        }
      ]
    }
  ],
  goodsOptions: [
    {
      value: "1",
      label: "钢材",
      isShow: false
    },
    {
      value: "2",
      label: "水泥及其制品",
      isShow: false
    },
    {
      value: "3",
      label: "沥青及其制品",
      isShow: false
    },
    {
      value: "4",
      label: "燃润料",
      isShow: false
    },
    {
      value: "5",
      label: "陆上施工设备",
      isShow: false
    },
    {
      value: "6",
      label: "水上施工设备",
      isShow: false
    },

    {
      value: "8",
      label: "其他金属材料",
      isShow: false
    },
    {
      value: "9",
      label: "木材及其竹木制品",
      isShow: false
    },
    {
      value: "10",
      label: "化轻、标准件及电工产品",
      isShow: false
    },
    {
      value: "11",
      label: "建筑装饰材料",
      isShow: false
    },
    {
      value: "12",
      label: "专用材料及工器具",
      isShow: false
    },
    {
      value: "13",
      label: "资产及服务类",
      isShow: false
    },
    {
      value: "14",
      label: "其他类型",
      isShow: false
    }
  ]
};
